module.exports = __webpack_public_path__ + "static/media/zumkha2-scop2.585e1507.png";